import { useTranslation } from "next-i18next";

import { useAuth } from "@/auth";
import { analyticsService } from "@/common/services/analytics/analytics.service";
import { CommonModal } from "@/components/common/modal/CommonModal";
import { CommonModalActionCancel } from "@/components/common/modal/actions/CommonModalActionCancel";
import { CommonModalActionProps } from "@/components/common/modal/contracts/modal.contracts";
import { closeModal, showModal } from "@/ui/Modal2";
import { Button } from "@/ui/cva/Button";

const AccountLogoutTitle = () => {
  const { t } = useTranslation();

  return <span>{t("common:common-log-out")}</span>;
};

const AccountLogoutContent = () => {
  const { t } = useTranslation();

  return (
    <span className="text-center">
      {t(
        "account:account-logout-confirm-body",
        "Are you sure you want to log out?"
      )}
    </span>
  );
};

const AccountLogoutConfirmAction = ({ modal }: CommonModalActionProps) => {
  const { t } = useTranslation();
  const { logout } = useAuth();

  const handleClick = () => {
    closeModal(modal);
    logout();
    analyticsService.trackLogout();
  };

  return (
    <Button color="brand" size="large" onClick={handleClick}>
      {t("account:account-logout-confirm-button", "Yes, log out")}
    </Button>
  );
};

/**
 * WHO-5453. Log out sits in the account menu footer next to Delete account,
 * so a slip of the mouse should cost a click, not a session.
 */
export const showAccountLogoutModal = () => {
  return showModal("common", {
    title: <AccountLogoutTitle />,
    content: <AccountLogoutContent />,
    actions: (modal: CommonModal) => [
      <CommonModalActionCancel key="cancel" modal={modal} />,
      <AccountLogoutConfirmAction key="confirm" modal={modal} />,
    ],
  });
};
